export { default } from './LocationHero';
